import { DocumentationCard } from "./documentation-card/DocumentationCard";

const cards = [
  {
    title: "Manual de Usuario",
    description:
      "Guía completa con instrucciones y recomendaciones para operar y mantener SP sin complicaciones.",
    downloadLink: process.env.REACT_APP_USER_GUIDE || "#",
    downloadText: "Descargar Manual",
  },
  {
    title: "Video de la misión",
    description:
      "Video en HD para reproducir en la zona de ingreso. Explicación de la misión.",
    downloadLink: process.env.REACT_APP_VIDEO_TUTORIAL || "#",
    downloadText: "Descargar Video",
  },
];

export const DocumentationScreen = () => {
  return (
    <div className="flex flex-col justify-between w-full min-h-screen px-20 bg-faux-dark-gunmetal pt-20">
      <div className="flex flex-col gap-10">
        <div className="flex flex-col gap-4">
          <h1 className="font-semibold font-orbitron text-[32px]">¡Hola!</h1>
          <p className="font-medium font-inter text-[16px]">
            Gestiona tu experiencia en un solo lugar.
          </p>
        </div>
        <div className="flex flex-row gap-20">
          {cards.map((card, index) => (
            <DocumentationCard
              key={index}
              title={card.title}
              description={card.description}
              downloadLink={card.downloadLink}
              downloadText={card.downloadText}
            />
          ))}
        </div>
      </div>
    </div>
  );
};
